<div
  class="main-font sidebar"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <div class="sidebar-link-container h-100">
    <div class="header-sidebar-container">
      <button class="transparent-btn btn-logo" routerLink="bacheca">
        <img src="assets/images/loghi/newLogoExt.svg" alt="" class="logo" />
      </button>
      <button
        class="transparent-btn edit-btn"
        *ngIf="isAdmin"
        (click)="openModalSections()">
        <i class="icons edit fill-svg-blue-700"></i>
      </button>
    </div>
    <div class="sections-container">
      <ul nz-menu nzMode="inline" class="pt-3">
        <ng-container *ngFor="let menu of menus; let i = index">
          <li
            *ngIf="shouldShowMenu(menu)"
            nz-submenu
            [nzTitle]="menuTemplate"
            [(nzOpen)]="openMenu[i]"
            (nzOpenChange)="openHandler(i)">
            <ng-template #menuTemplate>
              <div class="submenu-item">
                <i
                  class="d-flex align-items-center icons"
                  [ngClass]="[
                    allSubmenuDisabled(menu)
                      ? 'fill-svg-grey-600'
                      : 'fill-svg-blue-700',
                    menu.icon
                  ]"></i>
                <p
                  class="mb-0 text-submenu"
                  [ngStyle]="{
                    color: allSubmenuDisabled(menu)
                      ? 'var(--Grey-600)'
                      : 'var(--Blue-700)'
                  }">
                  {{ menu.title }}
                </p>
              </div>
            </ng-template>
            <ul *ngFor="let subMenu of menu.subMenus">
              <li
                nz-menu-item
                [nzMatchRouter]="true"
                class="p-0 m-0"
                [routerLink]="subMenu.pathLink"
                *ngIf="canAccessSection(subMenu.section)">
                <div class="sub-menu">
                  <i
                    class="d-flex align-items-center icons"
                    [ngClass]="[
                      isSectionActive(subMenu.section)
                        ? 'fill-svg-blue-700'
                        : 'fill-svg-grey-600',
                      subMenu.icon
                    ]"></i>
                  <p
                    class="mb-0 text-submenu"
                    [ngClass]="subMenu.icon"
                    [ngStyle]="{
                      color: isSectionActive(subMenu.section)
                        ? 'var(--Blue-700)'
                        : 'var(--Grey-600)'
                    }">
                    {{ subMenu.title }}
                  </p>
                </div>
              </li>
            </ul>
          </li>
        </ng-container>
        <li
          *ngIf="!isAdmin && pendingIllness?.status !== 'confirmed'"
          nz-menu-item
          class="p-0 m-0 sickness-container"
          [class.pending]="havePendingIllnsessRequest"
          (click)="openSicknessModal()">
          <i
            class="d-flex align-items-center justify-content-center icons"
            [ngClass]="{
              'sickness fill-svg-red-600': !havePendingIllnsessRequest,
              'info fill-svg-orange-700 scale': havePendingIllnsessRequest
            }"></i>
          <p class="mb-0 text-sickness text-submenu">
            {{
              havePendingIllnsessRequest
                ? 'Certifica malattia'
                : 'Segnala malattia'
            }}
          </p>
        </li>
      </ul>
    </div>
    <div class="h-100 d-flex align-items-end gamification">
      <app-new-gamification-card></app-new-gamification-card>
    </div>
    <div class="camillo h-100 d-flex flex-column justify-content-end">
      <img src="assets/images/camillo/camillo-front.svg" alt="camillo" />
      <div class="d-flex align-items-center gap-1">
        <img src="assets/images/camillo/camel-coin.svg" alt="" />
        <p class="mb-0 text-coin">1500</p>
      </div>
    </div>
  </div>
</div>
